import React from 'react'
import Banner from './banner/Banner'
import Trusted_content from './trusted_content/Trusted_content'
import Brands from './brands/Brands'
import Why_choose_us from './why_choose_us.js/Why_choose_us'
import What_we_offer from './what_we_offer/What_we_offer'
import Who_we_are from './who_we_are/Who_we_are'
import Success_speaks from './success_speaks/Success_speaks'
import Need_advice from './need_advice/Need_advice'
import Faq from './faq/Faq'
import Get_started from './get_started/Get_started'

function Home() {
  return (
    <>
      <Banner />
      <Trusted_content />
      <Brands />
      <Why_choose_us />
      <What_we_offer />
      <Who_we_are />
      <Success_speaks />
      <Need_advice imgSrc="/assets/images/home/need_advice/section_img_1.webp" />
      <Faq />
      <Get_started />
    </>
  )
}

export default Home